import React from "react";
import { PlusIcon, BankerAuctionEventsWrapper } from "app-v2";
import { useRouter } from "next/router";

interface Props {
  title?: string;
  eventTypes?: string[];
}

const ViewAuctionEvents: React.FC<Props> = ({
  title = "All Auction Events",
  eventTypes,
}) => {
  const router = useRouter();
  return (
    <div className="px-4 lg:px-8 py-6">
      <div className="flex justify-between">
        <h1 className="text-lg font-openSans font-normal text-bankerColor">
          {title}
        </h1>
        <button
          onClick={() => {
            router.push("/dashboard/events/create");
          }}
          className="flex justify-center items-center w-[125px] gap-1 bg-black text-white text-sm px-2 py-3 rounded-[12px]"
        >
          <PlusIcon />
          Create Event
        </button>
      </div>
      <div className="mt-4 border-2 border-gray-100">
        <BankerAuctionEventsWrapper eventTypes={eventTypes} />
      </div>
    </div>
  );
};

export default ViewAuctionEvents;
